import { render, staticRenderFns } from "./CardMessage.vue?vue&type=template&id=be81d4f0&scoped=true&"
import script from "./CardMessage.vue?vue&type=script&lang=js&"
export * from "./CardMessage.vue?vue&type=script&lang=js&"
import style0 from "./CardMessage.vue?vue&type=style&index=0&id=be81d4f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be81d4f0",
  null
  
)

component.options.__file = "CardMessage.vue"
export default component.exports